import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  singleOrNullrknfaxokm1sl as singleOrNull,
  first58ocm7j58k3q as first,
  toSet2orjxp16sotqu as toSet,
  singleOrNull21olsob387p54 as singleOrNull_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  PunchListItem1wbu5dz9rlo4k as PunchListItem,
  LineItem2rt64afaiyloc as LineItem,
} from '../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import { repeatForScopeSets14lknkq458s9b as repeatForScopeSets } from '../../utils/actions.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { confirmationDialog1lynowl7yd4cd as confirmationDialog } from './GenericConfirmationDialog.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ReactiveMutableList2gg4x024enrbf as ReactiveMutableList } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableList.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import {
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_atBottomzb604i67rgu3 as get_atBottom,
  get_expanding10cuv3ua9vajx as get_expanding,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { RemoveOutline_getInstance2r2ekg5cxorga as RemoveOutline_getInstance } from '../theming/appTheme.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
} from '../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../theming/separators.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../theming/sections.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { flattenml92kmikh8fo as flatten } from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Companion_getInstance2a03ktg5l3ejl as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_trash3qsdn4kaynjmu as get_trash } from '../../icons.mjs';
import { resize3py5p2yrjp6p7 as resize } from '../../utils/utils.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.bif_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  $this.aif_1.yhs_1.mam(tmp$ret$0);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, line, $completion) {
  var tmp = $this.cif_1.vfw().gfg_1.jfm(line.e6k_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var updated = tmp;
  var tmp_0 = (it) => it.e6k_1.equals(updated.e6k_1);
  $this.cif_1.ofv_1.eeo(tmp_0, (it) => updated);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = $this.dif_1.yhs_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = item.f2();
    destination.v(tmp$ret$0);
  }
  var adjustments = destination;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().u(collectionSizeOrDefault(adjustments, 10));
  var _iterator__ex2g4s_0 = adjustments.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var item_0 = _iterator__ex2g4s_0.o1();
    var tmp2_project = $this.dif_1.xhs_1;
    var tmp3_isMinorAdjustment = $this.dif_1.zhs_1;
    var tmp0_safe_receiver = $this.dif_1.vhs_1;
    var tmp4_scope = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f40();
    var tmp1_safe_receiver = singleOrNull($this.dif_1.uhs_1);
    var tmp5_lineItem = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e6k_1;
    var tmp$ret$3 = new (PunchListItem())(VOID, tmp2_project, tmp5_lineItem, tmp4_scope, VOID, item_0, false, VOID, VOID, tmp3_isMinorAdjustment);
    destination_0.v(tmp$ret$3);
  }
  var tasks = destination_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp = await_0(this_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = session.tfv_1.ceo(tasks, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = first($this.dif_1.uhs_1);
  var tmp_2 = repeatForScopeSets(tmp_1, MinorAdjustmentsDialog$render$slambda$slambda$slambda_0(session), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  $this.dif_1.whs_1($this.eif_1, true);
  return Unit_instance;
}
var MinorAdjustmentsDialog$render$slambda$slambda$slambdaClass;
function MinorAdjustmentsDialog$render$slambda$slambda$slambda() {
  if (MinorAdjustmentsDialog$render$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($session) {
        this.cif_1 = $session;
      }
      dgy(line, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, line), $completion);
      }
      s2(p1, $completion) {
        return this.dgy(p1 instanceof LineItem() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    MinorAdjustmentsDialog$render$slambda$slambda$slambdaClass = $;
  }
  return MinorAdjustmentsDialog$render$slambda$slambda$slambdaClass;
}
function MinorAdjustmentsDialog$render$slambda$slambda$slambda_0($session) {
  var i = new (MinorAdjustmentsDialog$render$slambda$slambda$slambda())($session);
  var l = (line, $completion) => i.dgy(line, $completion);
  l.$arity = 1;
  return l;
}
var MinorAdjustmentsDialog$render$slambda$slambdaClass;
function MinorAdjustmentsDialog$render$slambda$slambda() {
  if (MinorAdjustmentsDialog$render$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.dif_1 = this$0;
        this.eif_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MinorAdjustmentsDialog$render$slambda$slambdaClass = $;
  }
  return MinorAdjustmentsDialog$render$slambda$slambdaClass;
}
function MinorAdjustmentsDialog$render$slambda$slambda_0(this$0, $$this$button) {
  var i = new (MinorAdjustmentsDialog$render$slambda$slambda())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function MinorAdjustmentsDialog$_init_$lambda_1aw4zy(_this__u8e3s4, it) {
  get_dialogStack().pgd();
  return Unit_instance;
}
function MinorAdjustmentsDialog$_init_$lambda_1aw4zy_0(_this__u8e3s4, it) {
  get_dialogStack().pgd();
  return Unit_instance;
}
var MinorAdjustmentsDialog$render$slambdaClass;
function MinorAdjustmentsDialog$render$slambda() {
  if (MinorAdjustmentsDialog$render$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MinorAdjustmentsDialog$render$slambdaClass = $;
  }
  return MinorAdjustmentsDialog$render$slambdaClass;
}
function MinorAdjustmentsDialog$render$slambda_0() {
  var i = new (MinorAdjustmentsDialog$render$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MinorAdjustmentsDialog$render$slambdaClass_0;
function MinorAdjustmentsDialog$render$slambda_1() {
  if (MinorAdjustmentsDialog$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.fif_1 = this$0;
      }
      uao($completion) {
        this.fif_1.yhs_1.nam(Signal().hak(''));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MinorAdjustmentsDialog$render$slambdaClass_0 = $;
  }
  return MinorAdjustmentsDialog$render$slambdaClass_0;
}
function MinorAdjustmentsDialog$render$slambda_2(this$0) {
  var i = new (MinorAdjustmentsDialog$render$slambda_1())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var MinorAdjustmentsDialog$render$lambda$slambdaClass;
function MinorAdjustmentsDialog$render$lambda$slambda() {
  if (MinorAdjustmentsDialog$render$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $task) {
        this.aif_1 = this$0;
        this.bif_1 = $task;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MinorAdjustmentsDialog$render$lambda$slambdaClass = $;
  }
  return MinorAdjustmentsDialog$render$lambda$slambdaClass;
}
function MinorAdjustmentsDialog$render$lambda$slambda_0(this$0, $task) {
  var i = new (MinorAdjustmentsDialog$render$lambda$slambda())(this$0, $task);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var MinorAdjustmentsDialog$render$slambdaClass_1;
function MinorAdjustmentsDialog$render$slambda_3() {
  if (MinorAdjustmentsDialog$render$slambdaClass_1 === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.gif_1 = $$this$button;
        this.hif_1 = this$0;
      }
      uao($completion) {
        confirmationDialog(this.gif_1, 'Approve With Adjustments?', 'This releases funds for collection. Punch tasks created will notify the contractor and remain open until they mark them complete or inform you of any problems.', 'Approve', VOID, VOID, VOID, VOID, VOID, VOID, MinorAdjustmentsDialog$render$slambda$slambda_0(this.hif_1, this.gif_1));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MinorAdjustmentsDialog$render$slambdaClass_1 = $;
  }
  return MinorAdjustmentsDialog$render$slambdaClass_1;
}
function MinorAdjustmentsDialog$render$slambda_4($$this$button, this$0) {
  var i = new (MinorAdjustmentsDialog$render$slambda_3())($$this$button, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MinorAdjustmentsDialog$render$slambdaClass_2;
function MinorAdjustmentsDialog$render$slambda_5() {
  if (MinorAdjustmentsDialog$render$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.iif_1 = this$0;
        this.jif_1 = $$this$button;
      }
      uao($completion) {
        this.iif_1.whs_1(this.jif_1, false);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MinorAdjustmentsDialog$render$slambdaClass_2 = $;
  }
  return MinorAdjustmentsDialog$render$slambdaClass_2;
}
function MinorAdjustmentsDialog$render$slambda_6(this$0, $$this$button) {
  var i = new (MinorAdjustmentsDialog$render$slambda_5())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MinorAdjustmentsDialog$render$slambdaClass_3;
function MinorAdjustmentsDialog$render$slambda_7() {
  if (MinorAdjustmentsDialog$render$slambdaClass_3 === VOID) {
    class $ {
      constructor(this$0, $$this$dismissBackground2) {
        this.kif_1 = this$0;
        this.lif_1 = $$this$dismissBackground2;
      }
      uao($completion) {
        this.kif_1.whs_1(this.lif_1, false);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MinorAdjustmentsDialog$render$slambdaClass_3 = $;
  }
  return MinorAdjustmentsDialog$render$slambdaClass_3;
}
function MinorAdjustmentsDialog$render$slambda_8(this$0, $$this$dismissBackground2) {
  var i = new (MinorAdjustmentsDialog$render$slambda_7())(this$0, $$this$dismissBackground2);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MinorAdjustmentsDialogClass;
function MinorAdjustmentsDialog() {
  if (MinorAdjustmentsDialogClass === VOID) {
    class $ {
      static eht(lineItems, scope, dismiss) {
        scope = scope === VOID ? null : scope;
        var tmp;
        if (dismiss === VOID) {
          tmp = MinorAdjustmentsDialog$_init_$lambda_1aw4zy;
        } else {
          tmp = dismiss;
        }
        dismiss = tmp;
        var $this = createThis(this);
        $this.uhs_1 = lineItems;
        $this.vhs_1 = scope;
        $this.whs_1 = dismiss;
        var tmp_0 = $this;
        // Inline function 'kotlin.collections.map' call
        var this_0 = $this.uhs_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var tmp$ret$0 = item.f6k_1;
          destination.v(tmp$ret$0);
        }
        var tmp0_elvis_lhs = singleOrNull_0(toSet(destination));
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().o4($this.uhs_1.i1() ? 'MinorAdjustmentDialog cannot have an empty list of line items' : 'MinorAdjustmentDialog cannot work on multiple projects');
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp_0.xhs_1 = tmp_1;
        $this.yhs_1 = ReactiveMutableList().wam(listOf(Signal().hak('')));
        var tmp_2 = $this;
        var tmp0_safe_receiver = $this.vhs_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f99();
        tmp_2.zhs_1 = tmp1_elvis_lhs == null ? first($this.uhs_1).j6k_1 : tmp1_elvis_lhs;
        return $this;
      }
      static aht(lineItem, dismiss) {
        var tmp;
        if (dismiss === VOID) {
          tmp = MinorAdjustmentsDialog$_init_$lambda_1aw4zy_0;
        } else {
          tmp = dismiss;
        }
        dismiss = tmp;
        return this.eht(listOf(lineItem), VOID, dismiss);
      }
      wd6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.vbo(MinorAdjustmentsDialog$render$slambda_0());
        view.gba(get_AppDimensions().yg1_1);
        var tmp = view.kbb(view.jbb(DialogSemantic_getInstance()), get_centered(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.gba(get_AppDimensions().yg1_1);
        var tmp_0 = view_0.kbb(view_0.jbb(RemoveOutline_getInstance()), sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, get_rem(45)));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        view_1.bb9(get_AppDimensions().zg1_1);
        title(view_1, 'Minor Adjustments: ' + this.zhs_1);
        body(view_1, 'List minor adjustments to add as Punch Tasks (visible under Work_Tasks tab). Approving here releases funds for collection, Punch tasks will be handled before request for Final Completion and retention release.');
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.zbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.zbm(false);
        var tmp_1 = view_3.kbb(get_atBottom(view_3), get_expanding(view_3));
        // Inline function 'com.crowpay.views.theming.subTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextView())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.gbb(p_4, view_4);
        view_4.lba(view_4.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_2 = view_4.vb5_1;
        var tmp_3;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength('Tasks') === 0) {
          tmp_3 = '\xA0';
        } else {
          tmp_3 = 'Tasks';
        }
        tmp_2.hbu(tmp_3);
        view_3.hbb(p_4, view_4);
        view_3.lbb(tmp_1, view_4);
        var tmp_4 = view_3.kbb(get_centered(view_3), get_tertiaryButton(view_3));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Button())(view_3.pc());
        var tmp0_elvis_lhs_5 = view_3.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
        view_3.gbb(p_5, view_5);
        specCenteredText(view_5, '+ Task');
        onClick(view_5, 'Add Task', VOID, MinorAdjustmentsDialog$render$slambda_2(this));
        view_3.hbb(p_5, view_5);
        view_3.lbb(tmp_4, view_5);
        view_2.hbb(p_3, view_3);
        greySeparator(view_2);
        var tmp_5 = view_2.kbb(sizeConstraints(view_2, VOID, VOID, get_rem(6)), get_compact(view_2));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_6 = view_2.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_2 : tmp0_elvis_lhs_6;
        view_2.gbb(p_6, view_6);
        view_6.zbm(true);
        forEachUpdating(view_6, this.yhs_1, VOID, ($this$forEachUpdating, task) => {
          var tmp = get_lightSection($this$forEachUpdating);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$forEachUpdating.pc());
          var tmp0_elvis_lhs = $this$forEachUpdating.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
          $this$forEachUpdating.gbb(p, view);
          view.zbm(false);
          var tmp_0 = get_expanding(view);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp$ret$13 = view.jbb(FieldSemantic_getInstance());
          var tmp_1 = view.kbb(tmp_0, tmp$ret$13);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (TextInput())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.zah(view_0.icn_1, flatten(task));
          view.hbb(p_0, view_0);
          view.lbb(tmp_1, view_0);
          var tmp_2 = get_compact(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (Button())(view.pc());
          var tmp0_elvis_lhs_1 = view.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
          view.gbb(p_1, view_1);
          var tmp_3 = KMutableProperty0();
          var tmp_4 = Button$_get_enabled_$ref_61t7nx(view_1);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('enabled', 0, tmp_3, tmp_4, Button$_set_enabled_$ref_o8kynz(view_1));
          reactiveScope(view_1, ($this$reactiveScope) => {
            var tmp$ret$17 = $this$reactiveScope.daj(this.yhs_1).p1() > 1;
            this_0.set(tmp$ret$17);
            return Unit_instance;
          });
          view_1.lbb(view_1.kbb(get_centered(view_1), get_deleteButton(view_1)), icon(view_1, resize(get_trash(Companion_getInstance()), get_rem_0(1.2)), 'delete'));
          onClick(view_1, 'remove task', VOID, MinorAdjustmentsDialog$render$lambda$slambda_0(this, task));
          view.hbb(p_1, view_1);
          view.lbb(tmp_2, view_1);
          $this$forEachUpdating.hbb(p, view);
          $this$forEachUpdating.lbb(tmp, view);
          return Unit_instance;
        });
        view_2.hbb(p_6, view_6);
        view_2.lbb(tmp_5, view_6);
        view_1.hbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_7 = view_1.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_1 : tmp0_elvis_lhs_7;
        view_1.gbb(p_7, view_7);
        view_7.zbm(false);
        var tmp_6 = get_primaryButton(view_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (Button())(view_7.pc());
        var tmp0_elvis_lhs_8 = view_7.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
        view_7.gbb(p_8, view_8);
        var tmp_7 = KMutableProperty0();
        var tmp_8 = Button$_get_enabled_$ref_61t7nx_0(view_8);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_7, tmp_8, Button$_set_enabled_$ref_o8kynz_0(view_8));
        reactiveScope(view_8, ($this$reactiveScope) => {
          // Inline function 'kotlin.run' call
          var $this$run = $this$reactiveScope.daj(this.yhs_1);
          var tmp;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!$this$run.i1()) {
            var tmp$ret$35;
            $l$block_0: {
              // Inline function 'kotlin.collections.none' call
              var tmp_0;
              if (isInterface($this$run, Collection())) {
                tmp_0 = $this$run.i1();
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                tmp$ret$35 = true;
                break $l$block_0;
              }
              var _iterator__ex2g4s = $this$run.m1();
              while (_iterator__ex2g4s.n1()) {
                var element = _iterator__ex2g4s.o1();
                if (isBlank($this$reactiveScope.daj(element))) {
                  tmp$ret$35 = false;
                  break $l$block_0;
                }
              }
              tmp$ret$35 = true;
            }
            tmp = tmp$ret$35;
          } else {
            tmp = false;
          }
          var tmp$ret$39 = tmp;
          this_0.set(tmp$ret$39);
          return Unit_instance;
        });
        specCenteredText(view_8, 'Create & Approve');
        onClick(view_8, VOID, VOID, MinorAdjustmentsDialog$render$slambda_4(view_8, this));
        view_7.hbb(p_8, view_8);
        view_7.lbb(tmp_6, view_8);
        var tmp_9 = get_textButton(view_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (Button())(view_7.pc());
        var tmp0_elvis_lhs_9 = view_7.ebb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
        view_7.gbb(p_9, view_9);
        specCenteredText(view_9, 'Go Back');
        onClick(view_9, VOID, VOID, MinorAdjustmentsDialog$render$slambda_6(this, view_9));
        view_7.hbb(p_9, view_9);
        view_7.lbb(tmp_9, view_9);
        view_1.hbb(p_7, view_7);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_0, view_1);
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        view.vbo(MinorAdjustmentsDialog$render$slambda_8(this, view));
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'MinorAdjustmentsDialog', VOID, VOID, [Page()]);
    MinorAdjustmentsDialogClass = $;
  }
  return MinorAdjustmentsDialogClass;
}
//region block: exports
export {
  MinorAdjustmentsDialog as MinorAdjustmentsDialog1v336wr96b0sx,
};
//endregion

//# sourceMappingURL=MinorAdjustmentsDialog.mjs.map
